import { estateTaskAssignableTeams, teams } from '@/modules/team/store/team.state';
import { Team } from '@/modules/team/models/Team';
import { TeamCollection } from '@/modules/team/models/TeamCollection';

export function setEstateTaskAssignableTeams(teamList: Team[]): void {
  estateTaskAssignableTeams.value = TeamCollection.mapModel(teamList);
}

export function setTeams(teamList?: Team[]): void {
  if (!teamList) {
    teams.value = undefined;
    return;
  }

  teams.value = TeamCollection.mapModel(teamList);
}

